export interface AtMentionItem {
  id ?:string | number;
  name :string;
  type ?:AtMentionItemType;
  // could add more properties
}

export enum AtMentionItemType {
  USER = 'user',
  COMMAND = 'command',
  DIVIDER = 'divider',
}
export enum AtMentionCommands {
  TOPIC = '@topic',
  PROJECT = '@project',
}

export const UI_MENTION_COMMAND_KEYS :AtMentionCommands[] = [
  AtMentionCommands.TOPIC,
  AtMentionCommands.PROJECT,
];

const list = [
  {
    id: '123',
    name: 'John Doe',
    type: 'user',
  },
] as AtMentionItem[];
